module.exports = __webpack_public_path__ + "img/SB.02c49c0a.svg";